import React, { Component } from 'react';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import { getBranchesLatest } from '../../store/actions';
import withRouter from '../../components/lib/withRouter';
import { exportToExcel } from '../../utils/excelExport';

class ObjectiveExamsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            exams: [],
            selectedExam: null,
            selectedBranches: [],
            reportData: [],
            tableLoading: false,
        };

        this.service = new Service();
    }

    componentDidMount() {
        // this.props.getBranchesLatest(true);
    }

    onBranchesChange = (selectedBranches) => {
        if (selectedBranches && selectedBranches.length > 0) {
            this.setState({
                selectedBranches,
                selectedExam: null,
                reportData: []
            }, () => {
                this.getObjectiveExamsReport();
            });
        }
    };

    getObjectiveExamsReport() {
        const { selectedBranches } = this.state;

        if (!selectedBranches || selectedBranches.length === 0) {
            return;
        }

        this.setState({ tableLoading: true });

        this.service
            .post(`${baseUrlAdmin}/academicsReports/objectiveExamsReport`, {
                academicYear: localStorage.getItem('userAcademicYear'),
                branchIds: selectedBranches
            }, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    const rawData = response.res.data;

                    const exams = [...new Map(
                        rawData
                            .filter(item => selectedBranches.includes(item.branchId))
                            .map(item => [item.examId, { examId: item.examId, examName: item.examName }])
                    ).values()];

                    requestAnimationFrame(() => {
                        this.setState({
                            exams,
                            rawData,
                            selectedExam: null,
                            reportData: [],
                            tableLoading: false
                        });
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.setState({ tableLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch data',
                    life: 3000
                });
            });
    }

    onExamChange = (selectedExam) => {
        this.setState({ selectedExam, reportData: [] });
    };

    onViewAnalysis = () => {
        const { rawData, selectedExam, selectedBranches } = this.state;
        if (!selectedBranches.length || !selectedExam) return;

        const filteredData = rawData
            .filter(item =>
                item.examId === selectedExam.examId &&
                selectedBranches.includes(item.branchId)
            );

        // Process data method will be added later based on columns requirements
        this.setState({ reportData: filteredData });
    };

    render() {
        const { exams, selectedExam, selectedBranches, reportData, isLoading, tableLoading } = this.state;
        const { branchData } = this.props;

        return (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: '0',
                marginLeft: "100px",
                marginTop: "55px",
                overflow: 'auto',
            }}>
                <div className="card filters-card mt-1 pt-0">
                    <div className="flex">
                        {/* Branches MultiSelect */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Branches <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetMultiSelect
                                    value={selectedBranches}
                                    options={branchData}
                                    onChange={(e) => this.onBranchesChange(e.value)}
                                    optionLabel="name"
                                    optionValue="key"
                                    placeholder="Select Branches"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                />
                            </div>
                        </div>

                        {/* Exam Dropdown */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Exam <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetDropdown
                                    value={selectedExam}
                                    options={exams}
                                    onChange={(e) => this.onExamChange(e.value)}
                                    optionLabel="examName"
                                    placeholder="Select Exam"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                    disabled={!selectedBranches.length}
                                />
                            </div>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-2 order-1 ml-auto mt-5">
                            <Button
                                label="Download Report"
                                onClick={() => {
                                    const exportColumns = [
                                        { field: 'branchName', header: 'Branch Name' },
                                        { field: 'actualStrength', header: 'Actual Strength' },
                                        { field: 'appearedStrength', header: 'Appeared Strength' },
                                        { field: 'top10', header: 'TOP 10' },
                                        { field: 'rank11_20', header: '11-20' },
                                        { field: 'rank21_50', header: '21-50' },
                                        { field: 'rank51_100', header: '51-100' },
                                        { field: 'rank101_200', header: '101-200' },
                                        { field: 'rank201_500', header: '201-500' },
                                        { field: 'above501', header: 'above 501' }
                                    ];
                                    exportToExcel(reportData, 'Objective_Exams_Report', exportColumns);
                                }}
                                disabled={!reportData.length}
                                className="p-button-secondary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#fff",
                                    color: "#076EFF",
                                    marginRight: "10px"
                                }}
                            />
                            <Button
                                label="View Analysis"
                                onClick={this.onViewAnalysis}
                                disabled={!selectedExam || !selectedBranches.length}
                                className="p-button-primary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#076EFF",
                                    color: "#fff"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='datatable-report-demo mx-2' style={{ position: 'relative' }}>
                    {isLoading && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000
                        }}>
                            <LoadingComponent />
                        </div>
                    )}

                    <DataTable
                        value={reportData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                        responsiveLayout="scroll"
                        columnResizeMode="expand"
                        resizableColumns
                        className="p-datatable-custom"
                        loading={tableLoading}
                        loadingIcon="pi pi-spinner"
                        showLoader={false}
                        emptyMessage={
                            <div style={{ padding: '1rem' }}>
                                No results found
                            </div>
                        }
                    >
                        <Column
                            header="SNo"
                            body={(rowData, options) => options.rowIndex + 1}
                            style={{ width: '60px' }}
                            bodyStyle={{ textAlign: 'center' }}
                            headerStyle={{ textAlign: 'center' }}
                        />
                        <Column field="branchName" header="Branch Name" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="actualStrength" header="Actual Strength" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="appearedStrength" header="Appeared Strength" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="top10" header="TOP 10" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="rank11_20" header="11-20" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="rank21_50" header="21-50" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="rank51_100" header="51-100" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="rank101_200" header="101-200" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="rank201_500" header="201-500" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                        <Column field="above501" header="above 501" bodyStyle={{ textAlign: 'center' }} headerStyle={{ textAlign: 'center' }} />
                    </DataTable>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    branchData: (state.branchDataLatest?.data?.data.filter((each) => each.level === 1)) || [],
});

export default connect(mapStateToProps, { getBranchesLatest })(withRouter(ObjectiveExamsReport));